module.exports = __webpack_public_path__ + "img/w3_instagram_white.fdcbd8ec.png";